module.exports = __webpack_public_path__ + "static/aaaa-b5250a3c40461331b4e30fb399956ccf.jpg";